import React from 'react';
import HeroBanner from '../components/Home/HeroBanner';
import TeachingCareerSection from '../components/Home/TeachingCareerSection';
import NiecceStatsSection from '../components/Home/NiecceStatsSection';
import CoursesSection from '../components/Home/CoursesSection';
import StudentReviewsSection from '../components/Home/StudentReviewsSection';
import TransformSection from '../components/Home/TransformSection';
import ContactExpertsSection from '../components/Home/ContactExpertsSection';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
    <HeroBanner />
    <TeachingCareerSection />
    <NiecceStatsSection />
    <CoursesSection />
    <StudentReviewsSection />
    <TransformSection />
    <ContactExpertsSection />
    </>
  );
};

export default Home;
